<template>
  <div class="user-roles__datasources" v-if="user">
    <div class="user-roles__datasources__row">
      <div class="user-roles__datasources__controls">
        <div class="user-roles__datasources__controls-row">
          <div
            class="user-roles__datasources__controls-col"
            v-if="!isLocalAdmin"
          >
            <div
              :class="[
                'user-roles__datasources__controls-button',
                { multiEditMode: multiEditMode && !isLocalAdmin }
              ]"
              @click="toggleMultiEditMode"
            >
              <r-text>{{ $t("datasources:multi-editing") }}</r-text>
              <div class="r-input__icons arrow">
                <i class="el-icon-arrow-down" />
              </div>
            </div>
          </div>
        </div>
        <div
          class="user-roles__datasources__controls-row multi-editing"
          v-if="multiEditMode && !isLocalAdmin"
        >
          <div class="user-roles__datasources__controls-title">
            <r-text type="caption">
              {{ $t("datasources:multi-editing:title") }}
            </r-text>
          </div>
          <div class="user-roles__datasources__controls__multi-edit">
            <el-button
              :class="['r-button', { active: item.value }]"
              size="mini"
              v-for="item in crudsArray"
              :key="item.prop"
              @click="item.value = !item.value"
            >
              <i :class="`el-icon-${item.icon}`" />
              <r-text type="caption">{{ $t(`crud:${item.prop}`) }}</r-text>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="user-roles__datasources__row">
      <datasources-list
        :datasources="filteredNonActiveDs"
        :multi-edit="multiEditMode"
        :cruds-array="crudsArray"
      />
      <datasources-list
        :datasources="filteredActiveDs"
        :multi-edit="multiEditMode"
        :cruds-array="crudsArray"
        :secondary-ds="secondaryDs"
        :active-user-state="true"
      />
    </div>
  </div>
</template>

<script>
import datasourcesList from "./components/datasources-list";
import { crudsArray } from "../../configs";
import isEqual from "lodash.isequal";

export default {
  components: {
    datasourcesList
  },
  data() {
    return {
      multiEditMode: false,
      hasChanges: false,
      crudsArray
    };
  },
  watch: {
    userDS: {
      handler: function() {
        this.checkChanges();
      },
      deep: true,
      immediate: true
    },
    hasChanges: {
      handler: function(value) {
        this.$store.commit("SET_ACTIVE_USER_CHANGES", {
          module: "datasources",
          value
        });
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    user() {
      return this.$store.state.userRoles.activeUser;
    },
    datasources() {
      return this.$store.state.userRoles.allPerms.datasources
        .map(e => e)
        .sort((a, b) => {
          if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
          if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
          return 0;
        });
    },
    filteredNonActiveDs() {
      return this.datasources.filter(e => !this.isActiveDs(e.id));
    },
    filteredActiveDs() {
      return this.datasources.filter(e => this.isActiveDs(e.id));
    },
    secondaryDs() {
      const datasources =
        this.$store.state.userRoles.activeUserDatasources || [];

      return datasources.filter(
        e => this.datasources.findIndex(n => n.id === e.id) === -1
      );
    },
    userDS() {
      return this.$store.state.userRoles.activeUserDS;
    },
    initialUserDS() {
      return this.$store.state.userRoles.initialUserDS;
    },
    isLocalAdmin() {
      return this.$store.state.userRoles.activeUser.local_admin || false;
    }
  },
  methods: {
    isActiveDs(id) {
      const module = this.userDS.find(e => e.id === id);

      return !!(module && module._action !== "deleted");
    },
    toggleMultiEditMode() {
      this.multiEditMode = !this.multiEditMode;
    },
    checkChanges() {
      this.hasChanges = !isEqual(this.userDS, this.initialUserDS);
      this.$store.commit("SET_ACTIVE_USER_CHANGES", {
        module: "datasources",
        value: this.hasChanges
      });
    }
  }
};
</script>

<style lang="scss">
.user-roles__datasources {
  &__row {
    display: flex;
  }
  &__controls {
    width: 100%;
    max-width: 520px;
    &-title {
      margin-bottom: 12px;
      color: var(--white_white) !important;
    }
    &-row {
      display: flex;
      width: 100%;
      margin-bottom: 8px;
      &.multi-editing {
        background-color: var(--bg_containers) !important;
        border-radius: var(--border-radius);
        padding: 12px 16px;
        box-sizing: border-box;
        flex-direction: column;
        .r-button {
          background-color: transparent !important;
          border-color: var(--white_white) !important;
          padding: 4px 8px !important;
          span {
            display: flex;
            align-items: center;
            height: 18px;
            i {
              color: var(--white_white) !important;
            }
            .r-text {
              margin-left: 4px;
              margin-top: -3px;
              color: var(--white_white) !important;
            }
          }
          &.active {
            background-color: var(--accent_primary) !important;
            border-color: var(--accent_primary) !important;
          }
          &:hover {
            background-color: var(--accent_selected) !important;
          }
        }
      }
    }
    &-col {
      width: 100%;
      margin-right: 8px;
      position: relative;
      &:last-child {
        margin-right: 0;
      }
    }
    .r-input__icons {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 12px;
      height: calc(100% - 8px);
      width: 12px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
    }
    .r-input__icons {
      width: 16px;
      left: auto;
      right: 8px;
    }
    &__multi-edit {
      display: grid;
      grid-gap: 8px;
      grid-template-columns: repeat(4, 116px);
      grid-template-rows: repeat(2, 26px);
      button {
        margin: 0 !important;
      }
    }
  }
  &__controls-button {
    cursor: pointer;
    border: 1px solid;
    border-radius: var(--border-radius);
    width: 100%;
    height: 28px;
    padding: 4px 12px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-color: var(--field_border) !important;
    background-color: var(--field_bg) !important;
    &.multiEditMode {
      background-color: var(--bg_containers) !important;
      .r-text {
        color: var(--white_white) !important;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "datasources:multi-editing": "Режим мультиредактирования",
    "datasources:multi-editing:title": "Выберите необходимые права для назначения или удаления",

    "crud:create": "создание",
    "crud:read": "чтение",
    "crud:update": "обновление",
    "crud:delete": "удаление",
    "crud:share": "управление",
    "crud:export": "экспорт"
  },
  "en": {
    "datasources:multi-editing": "Multi-editing mode",
    "datasources:multi-editing:title": "Select the necessary rights to assign or delete",

    "crud:create": "create",
    "crud:read": "read",
    "crud:update": "update",
    "crud:delete": "delete",
    "crud:share": "manage",
    "crud:export": "export"
  }
}
</i18n>
